<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Venue checkins</h3>
        <p class="mt-5">
          These are the venues that have installed the REKOM DynamicForm plugin.
          This is required for a dynamic form to show.
        </p>
      </vs-col>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table ref="table" class="mt-8" pagination search max-items="50" :data="forms">
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Venue</vs-th>
          <vs-th>First seen</vs-th>
          <vs-th>Last seen</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.venueName }}
                </p>
              </vs-td>

              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ moment(tr.firstSeen).format(momentFormat) }}
                </vs-chip>
              </vs-td>

              <vs-td>
                <vs-chip color="warning" class="product-order-status">
                  {{ moment(tr.lastSeen).format(momentFormat) }}
                </vs-chip>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      moment,
      momentFormat: "DD-MM-YYYY HH:mm", // "DD-MM-YYYY HH:mm" for time
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      forms: "dynamicForms/venueCheckIns",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("dynamicForms/getVenueCheckIns", false);
    this.$vs.loading.close();
  },
};
</script>